<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Units')"
          :description="$t('From Here You Can Control The Measurement Units For The Products')"
        />
        <indexTable
          :searchText="$t('Search for a unit')"
          :emptyTableText="$t('There Are no Units')"
          :localData="true"
          :buttonRole="$checkRole('products_add')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :cloumns="[
            {
              column: 'name',
              title: $t('unitName'),
              type: 'text',
              sort: true
            },
            {
              column: 'unit',
              title: $t('Measruing Unit'),
              type: 'text',
              sort: true
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'edit', role: $checkRole('products_edit') },
                {
                  name: 'delete',
                  role: $checkRole('products_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/units'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
